<div class="row">
    <div class="col-sm-8 conditions-item">
        <div class="row">
            <div class="col-sm-8">
                <h2 class="main-color bold cursor-pointer"
                    (click)="togglePanel()">
                    {{ l(enrolledWorkDay.workDay | humanizeDate) }}
                </h2>
            </div>
            <div class="col-sm-4 text-right">
                <i class="fa cursor-pointer"
                    [title]="open?'Show less':'Show more'"
                    [ngClass]="{'fa-chevron-down': !open, 'fa-chevron-up': open }"
                    (click)="togglePanel()"></i>
            </div>
        </div>

        <div *ngIf="open">
            <p> {{ l('DescribeSiteConditions') }}</p>

            <div class="row mt-5">
                <div class="col-sm-6">
                    <label class="col d-block">{{l("Location")}} *</label>
                    <div class="col">
                        <select class="form-control"
                                (change)="updateLocation($event.target.value)"
                                [(ngModel)]="locationId"
                                [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted">
                            <option *ngFor="let item of locationsList"
                                    [value]="item.location.id">
                                {{ item.location.name }}
                            </option>
                        </select>
                    </div>
                    <div class="validation" *ngIf="!locationId">{{ l('SelectLocationValidation') }}</div>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-sm-6">
                    <div class="form-inline">
                        <label class="col d-block">{{l("ShiftStart")}} *</label>
                        {{enrolledWorkDay.workDay | humanizeDate}}
                        <div class="col">
                            <input class="form-control full-width pr-0" [disabled]="!isGranted('Pages.AllocationSheets.Edit')  || sheetData.isSubmitted"
							[(ngModel)]="shiftStart" type="time" min="00:00" max="23:59" pattern="[0-9]{2}:[0-9]{2}"
							(change)="updateShiftStart($event.target.value)" />
                        </div>
                    </div>
                    <div class="validation" *ngIf="!shiftStart">{{ l('SelectStartTime') }}</div>
                </div>
                <div class="col-sm-6">
                    <div class="form-inline">
                        <label class="col d-block">{{l("ShiftEnd")}} *</label>
                        <select class="form-control" [(ngModel)]="shiftEndDate" [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted" (change)="updateShiftEnd(shiftEnd)">
							<option *ngFor="let date of shiftEndDateArray"
							[value]="date">{{moment(date, dateFormat) | humanizeDate}}</option>
						</select>
						<div class="col">
							<input class="form-control full-width pr-0 margin-top" [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted"
							[(ngModel)]="shiftEnd" type="time" [min]="endMinTime" max="23:59"
							(change)="updateShiftEnd($event.target.value)" pattern="[0-9]{2}:[0-9]{2}" />
						</div>
                    </div>
                    <div class="validation" *ngIf="!shiftEnd">{{ l('SelectEndTime') }}</div>
                </div>
                <div class="col-sm-6 col-md-4 night-shift-box">
                    <div class="form-inline">
                        <label class="col d-block">{{l("NightShift")}}</label>
						<div class="col">
                            <mat-checkbox [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted"
                            [(ngModel)]="nightShift" (change)="updateNightShift(nightShift)"></mat-checkbox>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-sm-6">
                    <label class="col d-block">{{l("Weather")}} *</label>
                    <div class="col">
                        <select class="form-control" [(ngModel)]="weatherId"
                            [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted"
                            (change)="updateWeatherConditions($event.target.value)">
                            <option *ngFor="let weather of weatherPhenomenasList" [value]="weather.weatherPhenomena.id">
                                {{ weather.weatherPhenomena.name }}
                            </option>
                        </select>
                    </div>
                    <div class="validation" *ngIf="!weatherId">{{ l('SelectWeather') }}</div>
                </div>

                <div class="col-sm-6">
                    <div class="form-inline">
                        <label class="col d-block">{{ l('Rainfall') }}</label>
                        <div class="col">
                            <input type="text"
                                numbersOnly
                                class="form-control"
                                style="width: 50px;"
                                [(ngModel)]="rainfall"
                                (blur)="updateRainfall()"
                                [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted"/> mm
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-sm-12">
                    <label class="col d-block">{{ l('WorkSummary') }}</label>
                    <div class="col">
                        <textarea
                                class="form-control col-sm-12"
                                [(ngModel)]="workSummary"
                                (blur)="updateWorkSummary()"
                                maxlength="1000"
                                [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted" >
                        </textarea>
                        <p class="text-right pt-1" style="margin-bottom: 0">
                            <span [ngClass]="{'red': workSummary.length > 1000}"> {{ workSummary.length }}</span> / 1000
                        </p>
                    </div>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-sm-6">
                    <label class="col d-block">{{ l('ImpactedWork') }}</label>
                    <div class="col">
                        <select class="form-control"
                         [(ngModel)]="impactedWorkId"
                         [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted"
                        (change)="updateImpactedWork($event.target.value,'')">
                        <option *ngFor="let work of impactedWorkEvents" [value]=" work.impactedWorkEvent.id">
                            {{ work.impactedWorkEvent.name }}
                        </option>
                    </select>
                    </div>
                </div>
            </div>

            <div class="row mt-5">
                <div class="col-sm-12">
                    <div *ngFor="let impact of impactedWorkFormCtrl.value">
                        <div class="form-inline mt-5">
                            <label class="col-sm-4 d-block">{{ impact.impactedWorkEvent.name }}</label>
                            <div class="col">
                                <input type="text"
                                    class="form-control full-width"
                                    [(ngModel)]="impact.description"
                                    [disabled]="!isGranted('Pages.AllocationSheets.Edit') || sheetData.isSubmitted"
                                    (blur)="updateImpactedWork(impactedWorkId,impact.description)"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--
            <div class="row mt-5">
                <div class="col text-right">
                    <button class="btn btn-default"
                            (click)="copyConditionsToAllWorkDays()"
                            *ngIf="isGranted('Pages.AllocationSheets.Edit') &&  !sheetData.isSubmitted && (shiftStart && shiftEnd && locationId && hasWeatherValue)">
                        <i class="fas fa-calendar-check"></i> {{ l('ApplyAll') }}
                    </button>
                </div>
            </div>
            -->
        </div>
    </div>

</div>

